import _ from "lodash";
import Vue from "vue";
import { BASEURL } from "@/config/index";
import constant from "@/helper/constant";
import { getNumberFormatter } from "@/helper/currencyFormat";
import { getLangSpecificAttribute } from "@/helper/Languages";
import axios from "axios";
// import { getLangSpecificContent } from "@/helper/LanguageHelperV2";
import { authenticationService } from "@/services/AuthenticationService";

const beforeMount = function() {
  // this.$store.dispatch("fetchGlobalOptions");
  // this.$store.dispatch("fetchOrgDetails");
};

let userDetailsArray = {
  cinema_id: null,
  email_id: null,
  first_name: null,
  last_name: null,
  middle_name: null,
  mobile_no: null,
  role_id: null,
  user_id: null,
  username: null,
  role_name: null,
  distributor_id: null,
  cine_name: null,
  cine_direct_sale: null,
  cine_include_float_amount: null,
  cine_sell_fnb_in_boxoffice: null,
  pos_location_access: null,
  is_premier_kitchen_user: "N"
};
const data = function() {
  return {
    LOADING: null,
    AdminError:
      "Sorry! Something went wrong. kindly contact your administrator",
    GridViewFlag: false,
    NoRecords: "NoRecords",
    BASE_URL: constant.imageBaseURL,
    imageBaseURL: constant.imageBaseURL,
    imageS3BaseURL: constant.imageS3BaseURL,
    data_loading: false,
    usersArray: Object.keys(userDetailsArray),
    UsersDetails: {
      ...userDetailsArray
    },
    OrganizationGlobalOptions: [],
    secureStore: {
      set: authenticationService.set,
      get: authenticationService.get,
      remove: function(key) {
        window.localStorage.removeItem(key);
      }
    },
    toursShownOnPage: [],
    getMycinemaStatus: "N"
  };
};
const computed = {
  globaloptionsArr() {
    return this.$store.getters.getGlobalOptions;
  },
  _getCountryList() {
    return (key, Id) => {
      return [];
    };
  },
  TIME_FORMAT() {
    return this.$store.getters.TIME_FORMAT || "HH:mm";
  },
  cacheModePos() {
    let checkCacheMode = window.localStorage.getItem("cacheMode")
      ? window.localStorage.getItem("cacheMode")
      : "N";
    return checkCacheMode == "Y" ? true : false;
  },
  curr_code_mixin() {
    return this.$store.getters.getCurrencyData["curr_code"];
  },
  currency() {
    return this.$store.getters.getCurrencyData;
  },
  GetRoleId() {
    const { role_id } = authenticationService.get("USINFO");
    return role_id;
  },
  _DateFormat() {
    return constant.dateFormat;
  },
  currFormat() {
    let cFormat;
    let precesion;
    let global_options_latest = this.$store.getters.getGlobalOptions;
    // let global_options_latest = this.$store.getters.global_options_records;
    // console.log(global_options_latest, "global_options_latest");
    // console.log(new_global_option_data, "new_global_option_data");
    cFormat = global_options_latest
      ? global_options_latest.find(x => {
          return x.go_key == "CURR_FORMAT";
        })
      : null;
    precesion = global_options_latest
      ? global_options_latest.find(x => {
          return x.go_key == "MIN_FRACTION_DIGITS";
        })
      : null;
    if (cFormat && cFormat.go_value) {
      cFormat = cFormat.go_value;
    } else {
      cFormat = "en-US";
    }
    console.log(precesion, "precesion");
    if (precesion && precesion.go_value) {
      precesion = precesion.go_value;
    } else {
      precesion = 2;
    }
    return getNumberFormatter(cFormat, precesion);
  },
  currFormat3() {
    let cFormat;
    let precesion;
    let global_options_latest = this.$store.getters.getGlobalOptions;
    cFormat = global_options_latest
      ? global_options_latest.find(x => {
          return x.go_key == "CURR_FORMAT";
        })
      : null;
    precesion = global_options_latest
      ? global_options_latest.find(x => {
          return x.go_key == "MIN_FRACTION_DIGITS";
        })
      : null;
    if (cFormat && cFormat.go_value) {
      cFormat = cFormat.go_value;
    } else {
      cFormat = "en-US";
    }
    if (precesion && precesion.go_value) {
      precesion = precesion.go_value;
    } else {
      precesion = 2;
    }
    precesion = 3;
    return getNumberFormatter(cFormat, precesion);
  },
  currFormatLocal() {
    return getNumberFormatter("en-US", 0);
  },
  CLIENT_SETUP_NAME() {
    return this.$store.getters.CLIENT_SETUP_NAME;
  },
  MIN_FRACTION_DIGITS() {
    return this.$store.getters.MIN_FRACTION_DIGITS;
  },
  POS_AUDIT_LOGS_ACTIVE() {
    return this.$store.getters.POS_AUDIT_LOGS_ACTIVE;
  }
};
import MasterService from "@/services/MasterService";
import LogService from "@/services/LogService";
import moment from "moment";
const getFirstUserData = async user_id => {
  const { data } = await MasterService.GetUserInfoById({ user_id });
  return data;
};
const methods = {
  sendAuditLogs(payload) {
    if (this.POS_AUDIT_LOGS_ACTIVE == "Y") {
      let logObj = {
        user_name: null,
        user_id: this.getUserDetail("user_id"),
        cinema_id: this.getCinemaId(),
        action: null,
        page_name: null,
        logDateTime: null,
        api_name: window.location.hash,
        ip: null,
        country_name: null,
        country_code: null,
        latitude: null,
        longitude: null,
        currency_code: null,
        currency_name: null,
        ...payload
      };
      LogService.SendLog(logObj)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            console.log("Log Inserted");
          } else {
            console.error("Status Error on sendLogs :", data.message);
          }
        })
        .catch(error => {
          console.error("Catch Error on sendLogs :", error);
        });
    }
  },
  insertLogs(payload) {
    let logObj = {
      user_id: this.getUserDetail("user_id"),
      tbl_name: payload.tbl_name || "socket_events",
      query: payload.query || payload.page_name || "KITCHEN_SOCKET",
      remarks: payload.remarks || payload.action || ""
    };
    LogService.SendPosLog(logObj)
      .then(response => {
        const { data } = response;
        if (data && data.status) {
          console.log("Log Inserted");
        } else {
          console.error("Status Error on insertLogs :", data.message);
        }
      })
      .catch(error => {
        console.error("Catch Error on insertLogs :", error);
      });
  },
  // authorizeClient(clientNames) {
  //   let isShow = false;
  //   let globaloptionsArr = this.globaloptionsArr;
  //   let clientSetupName = globaloptionsArr.find((globalOption) => {
  //     return globalOption.go_key == "CLIENT_SETUP_NAME";
  //   })["go_value"];

  //   if (clientNames.length > 0 && clientSetupName) {
  //     isShow = clientNames.includes(clientSetupName);
  //   }

  //   return isShow;
  // },
  authorizeClient(clientNames) {
    try {
      if (!clientNames) return false;

      const globaloptionsArr = this.globaloptionsArr || [];

      const clientSetupObj = globaloptionsArr.find(
        globalOption => globalOption.go_key === "CLIENT_SETUP_NAME"
      );

      const clientSetupName = clientSetupObj && clientSetupObj.go_value;

      if (!clientSetupName) return false;

      if (Array.isArray(clientNames)) {
        return clientNames.includes(clientSetupName);
      }

      if (typeof clientNames === "string") {
        return clientNames === clientSetupName;
      }

      return false;
    } catch (err) {
      console.log("authorizeClient error:", err);
      return false;
    }
  },
  showLoading: function() {
    this.hideLoading(true);
    this.$nextTick(() => {
      this.LOADING = this.$loading.show();
    });
  },
  hideLoading: function(immediate = false) {
    if (!immediate) {
      this.$nextTick(() => {
        if (this.LOADING) this.LOADING.hide();
      });
    } else {
      if (this.LOADING) this.LOADING.hide();
    }
  },
  getRequestBody: function(method = "GET", array = [], Methods = {}) {
    let payload = {};
    (async function() {
      const promises = array.map(x => {
        payload[x.fieldname] = x.fieldvalue;
      });
      await Promise.all(promises);
      // payload['table'] = Methods["tableName"]
    })();
    if (method == "POST") {
      return {
        url: Methods[method] + Methods["tableName"], // + Methods["urlKey"],
        method,
        payload
      };
    } else if (method == "PUT") {
      let url = null;
      console.log("Method :", Methods["params"]);
      if (Methods["params"]) {
        url =
          Methods[method] +
          Methods["tableName"] +
          `/${Methods["params"]["id"]}`;
      } else {
        url = Methods[method] + Methods["tableName"];
      }
      console.log("url :", url);

      return {
        url,
        method: "PUT",
        payload
      };
    } else if (method == "GET") {
      let url = null;
      if (Methods["params"]) {
        url =
          Methods[method] +
          Methods["tableName"] +
          `/${Methods["params"]["id"]}`;
      } else {
        url = Methods[method] + Methods["tableName"];
      }

      return {
        url,
        method: "GET",
        payload: {}
      };
    } else if (method == "GET_ONE") {
      let url = null;
      if (Methods["params"]) {
        url =
          Methods[method] +
          Methods["tableName"] +
          `/${Methods["params"]["id"]}`;
      } else {
        url = Methods[method] + Methods["tableName"];
      }

      return {
        url,
        method: "GET",
        payload: {}
      };
    } else {
      return {
        url: "",
        method: "GET",
        payload: {}
      };
    }
  },
  /**
   * How to use Ref: [https://github.com/vuejs/vue/issues/11088#issuecomment-630287153]
   *  <template>
   *    <div>
   *      {{ getSafe(() => obj.foo.bar) }} ............................ <!-- returns 'baz' -->
   *      {{ getSafe(() => obj.foo.doesNotExist) }} ................... <!-- returns undefined -->
   *      {{ getSafe(() => obj.foo.doesNotExist, 'fallbackValue') }}... <!-- returns 'fallbackValue' -->
   *    </div>
   *  </template>
   */
  getSafe(
    fn,
    fallbackValue = undefined,
    useFallbackForFalsyGetSafeValue = true
  ) {
    try {
      let result = fn();

      if (!result && useFallbackForFalsyGetSafeValue) {
        result = fallbackValue;
      }

      return result;
    } catch (e) {
      return fallbackValue;
    }
  },

  validateShowCinema(cinema_id) {
    console.log(
      "VALIDATING CINEMA...",
      cinema_id,
      authenticationService.get("USINFO").cinema_id
    );
    let loggedCinemaId = window.localStorage.getItem("cinema_id");
    let userId = authenticationService.get("USINFO").user_id;
    let status = true;
    if (cinema_id && loggedCinemaId) {
      if (
        cinema_id == authenticationService.get("USINFO").cinema_id &&
        loggedCinemaId == cinema_id
      ) {
        status = true;
      } else {
        status = false;
      }
    } else {
      status = false;
    }
    if (!status) {
      this.$store.dispatch("onSetAndSendLog", {
        action: `Validate Cinema ID FALIED WE GET SHOW CINEMA ID ${cinema_id} but USER CINEMA ID IS ${loggedCinemaId} and user id is ${userId}`,
        page_name: "POS booking",
        api_name: window.location.hash
      });
    }
    console.log("VALIDATE CINEMA STATUS", status);
    return status;
  },
  getNegativeValue(value) {
    if (value) {
      return "-" + parseFloat(value).toFixed(this.MIN_FRACTION_DIGITS);
    } else {
      return parseFloat(0).toFixed(this.MIN_FRACTION_DIGITS);
    }
  },
  getGlobalOptionKey(key_name) {
    if (this.$store) {
      let global_array = this.$store.getters.getGlobalOptions;
      if (global_array.length > 0) {
        return global_array;
      }
    }
  },
  getMyCinemaStatusNew() {
    return this.secureStore.get("MYCINEMASTATUS");
  },
  goBack: function(error) {
    this.$router.go(-1);
  },
  _CatchError: function(error) {
    // console.log('errr::::', error)
    Vue.toasted.show(
      error || "Sorry! Something went wrong. kindly contact your administrator"
    );
  },
  _GoToSomethingWentWrong: function() {
    this.$router.push({
      path: "/something-went-wrong"
    });
  },
  _GoToAccessDenied: function() {
    this.$router.push({
      path: "/access-denied"
    });
  },
  _GoToError404: function() {
    this.$router.push({
      path: "/404"
    });
  },
  _GoToRoute: function(path) {
    this.$router.push({
      path: path
    });
  },

  GetViewUsersDetails: function(user_id) {
    let string = "";
    let promise = getFirstUserData(user_id).then(res => {
      string =
        res.status && res["Records"] && res.Records.length > 0
          ? res.Records[0].user_name
          : "-";
    });
    // console.log('promise :', promise);
    // console.log('string :', string);
    // getFirstUserData(user_id).map(x => { console.log('x :', x); })
    return promise;
  },
  CreateFilterObject: function(array) {
    let obj = {};
    array.map(x => {
      obj[x.key] = "";
    });
    return obj;
  },
  GetMonthFirstDate: function() {
    var d = new Date(),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, "01"].join("-");
  },
  GetCurrentDate: function() {
    var d = new Date(),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  },
  formatDate: function(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [year, month, day].join("-");
  },
  _formatDate_dd_mm_yyyy: function(date) {
    var d = new Date(date);
    let formatted_date =
      d.getDate() +
      "-" +
      (d.getMonth() + 1) +
      "-" +
      d.getFullYear() +
      " " +
      d.getHours() +
      ":" +
      d.getMinutes();
    return formatted_date;
  },

  _GetImagePath: function(imagePath) {
    if (imagePath && imagePath.length > 0) {
      var expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
      var regex = new RegExp(expression);

      if (imagePath.match(regex)) {
        return imagePath;
      }

      // console.log('imagePath.match(/S3\//g)', imagePath.match(/S3\//g));
      // console.log('imagePath', imagePath);

      // if (imagePath.match(/S3\//g)) {

      if (imagePath.startsWith("S3/") || imagePath.includes("/S3/")) {
        return `${constant.imageS3BaseURL}${imagePath}`;
      } else {
        return `${constant.imageBaseURL}${imagePath}`;
      }
    }
  },

  _downloadImagePath: function(imagePath, fileName) {
    let imageUrl = `${constant.imageBaseURL}${imagePath}`;
    axios
      .get(imageUrl, { responseType: "blob" })
      .then(response => {
        console.log(response.data);
        const blob = new Blob([response.data]);
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
      })
      .catch(console.error);
  },
  // getCurrentDateNew(format) {
  //   if (format) {
  //     return moment().format(format);
  //   } else {
  //     return moment().format("YYYY-MM-DD");
  //   }
  // },
  getCurrentDateNew(format, type = "business") {
    if (type == "business") {
      const now = moment();
      const dayStartHour = 6;

      const adjusted = now.hour() < dayStartHour ? now.subtract(1, "day") : now;

      return adjusted.format(format || "YYYY-MM-DD");
    } else {
      if (format) {
        return moment().format(format);
      } else {
        return moment().format("YYYY-MM-DD");
      }
    }
  },
  getCurrentTime() {
    return moment().format("HH:mm");
  },

  getCinemaId() {
    return localStorage.getItem("cinema_id") || null;
  },
  getUserDetail(key = null) {
    let user_info = localStorage.getItem("USER_INFO") || null;
    if (user_info) {
      user_info = JSON.parse(localStorage.getItem("USER_INFO"));
    }
    if (key) {
      return user_info[key];
    } else {
      return user_info;
    }
  },
  getUserShiftData(key = null) {
    let user_info = localStorage.getItem("USER_SHIFT_DATA") || null;
    if (user_info) {
      user_info = JSON.parse(localStorage.getItem("USER_SHIFT_DATA"));
    }
    if (key) {
      return user_info[key];
    } else {
      return user_info;
    }
  },
  getSpecificGlobalOption(key = null) {
    let globalOptions = this.globaloptionsArr;
    let globalOptionValue = "";
    if (globalOptions.length > 0 && key != null) {
      let findGlobalOption = globalOptions.find(globalOption => {
        return globalOption.go_key === key;
      });
      if (findGlobalOption && Object.keys(findGlobalOption).length > 0) {
        globalOptionValue = findGlobalOption.go_value;
      } else {
        globalOptionValue = "";
      }
    }
    console.log({ globalOptionValue }, "from globalOtpionValue");
    return globalOptionValue;
  },

  getLangSpecificAttribute
  // getLangSpecificContent,
};

const beforeDestroy = function() {};

const storeService = {
  data: () => data(),
  computed,
  beforeMount,
  methods,
  beforeDestroy
};

export default storeService;



// WEBPACK FOOTER //
// ./src/util/utilMixin/index.js